import type ConversationType from 'owa-service/lib/contract/ConversationType';
import type ItemId from 'owa-service/lib/contract/ItemId';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { addToMeetingItemFetchList } from './meetingItemFetchListOperations';
import { shouldShowRSVPBasedOnInitialCheck } from './shouldShowRSVPBasedOnInitialCheck';

/**
 * Prepares meeting data for the conversation
 * @returns whether to show RSVP for the conversation
 * @param conversationType payload for the conversation to be added or updated
 * @param tableView The Table view
 */
export const prepareMeetingDataForConversationAndGetShouldShowRSVP = (
    conversationType: ConversationType,
    tableView: TableView
) => {
    if (!conversationType.ItemClasses?.length || !conversationType.ItemIds?.length) {
        return false;
    }

    // We always use the latest ItemId/ItemClass
    const itemId = (conversationType.ItemIds[0] as ItemId)?.Id;
    const itemClass = conversationType.ItemClasses[0];
    if (!shouldShowRSVPBasedOnInitialCheck(itemId, itemClass, tableView)) {
        return false;
    }

    addToMeetingItemFetchList(itemId, tableView.id, conversationType.ConversationId?.Id);
    return true;
};
